"use client"
/* */
import { mergeProps } from '@react-aria/utils';
import { isObjectType } from 'remeda';
import { setProperty } from 'dot-prop';

const getPropsMerger = (options = {}) => (...propsList) => {
  const { mergeClassNames = true, mergeEventHandler = true } = options;
  const mergedProps = mergeProps(...propsList);
  if (isObjectType(mergedProps)) {
    if (!mergeClassNames) {
      for (const props of propsList) {
        if (isObjectType(props) && "className" in mergedProps && "className" in props) {
          mergedProps.className = props.className;
        }
      }
    }
    if (!mergeEventHandler) {
      for (const props of propsList) {
        if (isObjectType(props)) {
          for (const [propName, propValue] of Object.entries(props)) {
            const isEventHandlerProp = /^on[A-Z]/.test(propName);
            if (isEventHandlerProp) {
              setProperty(mergedProps, propName, propValue);
            }
          }
        }
      }
    }
  }
  return mergedProps;
};

export { getPropsMerger };
//# sourceMappingURL=getPropsMerger.mjs.map
